import { useState } from 'react';
import Button from 'src/components/buttons/button';
import config from 'config/config';
import Icon from 'src/components/icon';

const PROGRAM_URL = `${config.cdn.navigator}lower-your-cholesterol/`;

const getMenu = () => (
  <section className="navigator__contents">
    <div className="navigator__contents-header">Contents</div>
    <ul className="navigator__contents__list">
      <li>
        <div className="navigator__contents__number">1.</div>
        <div className="navigator__contents__content-text">
          <a href="#1">What is high cholesterol?</a>
        </div>
      </li>
      <li>
        <div className="navigator__contents__number">2.</div>
        <div className="navigator__contents__content-text">
          <a href="#2">What does cholesterol have to do with cardiovascular disease?</a>
        </div>
      </li>
      <li>
        <div className="navigator__contents__number">3.</div>
        <div className="navigator__contents__content-text">
          <a href="#3">Introducing the programme</a>
        </div>
      </li>
    </ul>
  </section>
);

const getPage = () => (
  <div className="navigator">
    <section className="navigator__content">
      <h1 className="navigator__title">Week 1: Understanding cholesterol</h1>
      <p>
        In this first week, you can learn more about what cholesterol is and why it’s a big deal.
      </p>
      <div className="visible-xs">{getMenu()}</div>

      <h2>What is high cholesterol?</h2>
      <p>
        Cholesterol is a fatty substance in our blood, which is produced naturally in the liver. Everyone has
        cholesterol. We need it to stay healthy because every cell in our body uses it. Some of this cholesterol comes
        from the food that we eat.
      </p>
      <p>
        There are two main types of cholesterol - one is good and the other is bad. Having too much bad cholesterol can
        clog up your arteries, the blood vessels that carry blood to your major organs. If the arteries that carry blood
        to your heart get damaged and clogged, it can lead to a heart attack. If this happens in the arteries that carry
        blood to your brain it can lead to a stroke.
      </p>
      <p>
        Anyone can get high cholesterol, but there are things you can do to lower your risk of heart and circulatory
        diseases.
      </p>
      <a
        href="http://images.hu-production.be.s3.amazonaws.com/programs/lower-your-cholesterol/Week1-BHF-understanding-cholesterol.pdf"
        rel="noreferrer"
        target="_blank"
      >
        <Button
          icon="open-right"
          iconLeftAligned={false}
          text="Download the BHF cholesterol leaflet"
        />
      </a>

      <h2>What does cholesterol have to do with cardiovascular disease?</h2>
      <p>Watch this video to find out.</p>
      <div className="navigator__video-container">
        <iframe
          allow="autoplay; encrypted-media; fullscreen"
          src="https://www.youtube.com/embed/_qzT246x8DE"
        />
      </div>

      <h2>Introducing the programme</h2>
      <img alt="Low, medium, high cholesterol guage, with needle pointing to normal" className="navigator__image-half" src={`${PROGRAM_URL}W01B03.jpg`} />
      <p>
        This 12-week programme will guide you through understanding high cholesterol and what it means, and steps you
        can take to bring your cholesterol to a healthier level for you.
      </p>
      <p>
        We’ll cover how to eat well, move more, and make other lifestyle choices that will help protect your health in
        the long run.{' '}
      </p>
      <p>
        We’ll also give you information about medications, including statins, and how they can work alongside these
        lifestyle changes to lower your cholesterol.{' '}
      </p>

      <img alt="Content provided by BHF" className="navigator__image-full navigator__banner-footer" src={`${PROGRAM_URL}bhf-content.jpg`} />
    </section>
  </div>
);

function Footer() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;
  return (
    <div className="navigator__footer">
      <img alt="heart matter call to action" className="navigator__footer__image" src={`${PROGRAM_URL}cta-heartmatters.png`} />
      <div className="navigator__footer__inner">
        <div className="navigator__footer__title">Heart Matters can keep your heart healthy</div>
        <div className="navigator__footer__description">
          Heart Matters offers FREE information and support to help you look after your heart.{' '}
          <a
            className="navigator__footer__link"
            href="https://www.bhf.org.uk/heart-health/how-we-can-help/heart-matters"
            rel="noreferrer"
            target="_blank"
          >
            Subscribe for free here {'>'}
          </a>
        </div>
        <div className="navigator__footer__close" onClick={() => setVisible(false)}>
          <Icon icon="cross" />
        </div>
      </div>
    </div>
  );
}

const obj = {
  getPage,
  getMenu,
  Footer,
  getSeoTitle: 'Lower your cholesterol | HealthUnlocked',
};

export default obj;
